import { useMutation } from '@tanstack/react-query';
import { axios } from '@repo/http';
export function useChangePassword() {
    return useMutation({
        mutationFn: (password)=>axios.post('/v2/user/change-password', {
                password
            })
    });
}
